import { motion } from "framer-motion";
import { Crown, Scissors, Slice } from "lucide-react";
import { LogoLockup } from "@/components/Logo";

const VALUES = [
  { icon: Scissors, top: "Excelência", bottom: "em cada corte" },
  { icon: Slice, top: "Estilo", bottom: "que inspira" },
  { icon: Crown, top: "Confiança", bottom: "que transforma" },
];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1], delay },
});

export default function Hero({ onBook }) {
  return (
    <section id="inicio" className="relative overflow-hidden px-6 pb-14 pt-12">
      <div className="pointer-events-none absolute inset-x-0 top-0 z-0 h-[560px]" aria-hidden="true">
        <img
          src="/horarios-poster.jpg"
          alt=""
          className="h-full w-full object-cover opacity-25 [mask-image:linear-gradient(to_bottom,black_30%,transparent)]"
          style={{ filter: "blur(8px) brightness(0.4) saturate(0.55) sepia(0.3)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0C0C0A]/30 via-[#0C0C0A]/60 to-[#0C0C0A]" />
      </div>

      <div className="relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="relative"
      >
        <LogoLockup />
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.35 }}
        className="mt-6 text-center text-sm text-stone-400"
      >
        Seu estilo. Sua identidade. Nossa paixão.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
        className="mt-9"
      >
        <button
          type="button"
          onClick={onBook}
          className="gold-btn w-full"
          data-testid="hero-cta-booking"
        >
          Reservar Horário
        </button>
      </motion.div>

      <motion.div {...fadeUp(0.1)} className="mt-12 grid grid-cols-3 divide-x divide-amber-500/15">
        {VALUES.map((v, i) => (
          <div key={v.top} className="flex flex-col items-center gap-2.5 px-2 text-center" data-testid={`value-item-${i}`}>
            <v.icon size={22} strokeWidth={1.6} className="text-amber-400" />
            <p className="text-[13px] font-semibold leading-tight text-amber-100">
              {v.top}
              <br />
              <span className="text-xs font-normal text-stone-500">{v.bottom}</span>
            </p>
          </div>
        ))}
      </motion.div>

      <motion.figure
        {...fadeUp(0.15)}
        id="horarios"
        className="mt-12"
        data-testid="opening-hours-table"
      >
        <div className="overflow-hidden rounded-2xl border border-amber-500/25 bg-black shadow-[0_12px_44px_rgba(0,0,0,0.65),0_0_0_1px_rgba(212,175,55,0.08)]">
          <img
            src="/horarios-poster.jpg"
            alt="Cartaz de horário de funcionamento: Terça a Quinta 11h às 21h, Sexta e Sábado 11h às 22h, Domingo e Segunda fechado"
            className="w-full"
            style={{ filter: "brightness(0.88) saturate(0.7) sepia(0.12)" }}
            loading="lazy"
            data-testid="hours-poster"
          />
        </div>
        <figcaption className="mt-3 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-stone-500">
          Ter–Qui 11h–21h · Sex–Sáb 11h–22h · Dom e Seg fechado
        </figcaption>
      </motion.figure>

      <motion.p
        {...fadeUp(0.2)}
        className="mt-12 text-center text-[10px] uppercase tracking-[0.45em] text-amber-500/50"
      >
        Seu estilo. Sua identidade.
      </motion.p>
      </div>
    </section>
  );
}
